import CHECKOUT_STEPS_ROUTES from '../../routes/checkout';
import { setRoute } from '../../actions/routes';

const getNextRouteForCartType = (isDownloadOnly) =>
  setRoute(
    isDownloadOnly
      ? CHECKOUT_STEPS_ROUTES.review.path
      : CHECKOUT_STEPS_ROUTES.delivery.path
  );

export default getNextRouteForCartType;
